import { useState, useEffect } from 'react';
import qs from 'qs';

export default () => {
  const [query, setQuery] = useState<{
    [key: string]: number | boolean | string;
  }>({});

  useEffect(() => {
    const handlHash = () => {
      const q: any = qs.parse(window.location.hash.slice(1));

      setQuery(q);
    };

    window.addEventListener('hashchange', handlHash);

    handlHash();

    return () => {
      window.removeEventListener('hashchange', handlHash);
    };
  }, []);

  return {
    query,
    setQuery: (key: string, value: any) => {
      const querystring = qs.stringify({
        ...query,
        [key]: value,
      });

      window.location.hash = querystring;
    },
    setQueryObj: (queryObj: Record<string, any>) => {
      const querystring = qs.stringify({
        ...query,
        ...queryObj,
      });

      window.location.hash = querystring;
    },
    removeQuery: (key: string) => {
      delete query[key];
      setQuery(query);
    },
    resetQuery: (queryObj: Record<string, any>) => {
      const querystring = qs.stringify({
        ...queryObj,
      });

      window.location.hash = querystring;
    },
  };
};
